module.exports = __webpack_public_path__ + "img/leftpop.77affa0d.png";